import script from "./SearchByMonth.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchByMonth.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__